var _path, _circle;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHelp(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.708 13.738C10.708 13.2807 10.7827 12.87 10.932 12.506C11.0813 12.142 11.3893 11.8247 11.856 11.554C11.996 11.47 12.1687 11.372 12.374 11.26C12.5793 11.148 12.78 11.0173 12.976 10.868C13.172 10.7187 13.3353 10.546 13.466 10.35C13.606 10.154 13.676 9.92533 13.676 9.664C13.676 9.28133 13.5407 8.98733 13.27 8.782C12.9993 8.56733 12.6913 8.46 12.346 8.46C11.9353 8.46 11.5947 8.586 11.324 8.838C11.0533 9.08067 10.8433 9.328 10.694 9.58L9.476 8.74C9.71867 8.17067 10.106 7.72733 10.638 7.41C11.1793 7.09267 11.7673 6.934 12.402 6.934C12.878 6.934 13.3353 7.032 13.774 7.228C14.222 7.41467 14.5907 7.71333 14.88 8.124C15.1693 8.52533 15.314 9.048 15.314 9.692C15.314 10.2893 15.1787 10.7653 14.908 11.12C14.6373 11.4653 14.2827 11.7733 13.844 12.044C13.592 12.1933 13.3447 12.338 13.102 12.478C12.8593 12.618 12.654 12.786 12.486 12.982C12.3273 13.1687 12.248 13.4207 12.248 13.738H10.708ZM10.736 17V15.068H12.29V17H10.736Z",
    fill: "currentColor"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 8.5,
    stroke: "currentColor"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHelp);
export default __webpack_public_path__ + "static/media/help.57cbf51d.svg";
export { ForwardRef as ReactComponent };